const scrollToForm = () =>
  document.getElementById("waitlist")?.scrollIntoView({ behavior: "smooth", block: "start" });

export const Hero = () => (
  <header>
    <div className="top">
      <div className="logo" data-testid="nobo-logo">nobo<b>.</b></div>
      <button type="button" className="pill" onClick={scrollToForm} data-testid="hero-pill-cta">
        limited spots, picked by us
      </button>
    </div>
    <h1>
      <span>nobo</span>
      <span className="run">run club</span>
      <button type="button" className="sticker" onClick={scrollToForm} data-testid="hero-join-sticker">
        waitlist open
      </button>
    </h1>
    <p className="lede">
      No one gets left behind. No pace police. No pressure to be fast.{" "}
      <em>Just show up in whatever shoes you own.</em>
    </p>
    <p className="why">
      We do it for the love of sport. <mark>By athletes, for everyone.</mark>
    </p>
    <button type="button" className="hero-cta" onClick={scrollToForm} data-testid="hero-join-waitlist-button">
      join the waitlist ↓
    </button>
  </header>
);
